export function fillMarqueeTrack(track) {
  let cancelled = false;
  let rafId = null;

  const cloneItems = () => {
    if (cancelled || track.dataset.marqueeCloned === "true") return;

    const baseWidth = track.scrollWidth;
    if (!baseWidth) {
      rafId = requestAnimationFrame(cloneItems);
      return;
    }

    const items = Array.from(track.children);
    const cloneCount = Math.ceil(window.innerWidth / baseWidth) + 1;

    if (!Number.isFinite(cloneCount) || cloneCount <= 0) {
      return;
    }

    track.dataset.marqueeCloned = "true";

    for (let i = 0; i < cloneCount; i++) {
      items.forEach((item) => {
        track.appendChild(item.cloneNode(true));
      });
    }
  };

  rafId = requestAnimationFrame(cloneItems);

  return () => {
    cancelled = true;
    if (rafId !== null) {
      cancelAnimationFrame(rafId);
    }
  };
}
